export const SPECIAL_DAYS_HELP =
  'วันพิเศษใช้กับ rule ระดับ TC เท่านั้น: rule TC จะส่งเฉพาะวันที่ตรงกับประเภทวันพิเศษที่เลือก (และ cron ต้องตรงชั่วโมงนั้นด้วย) ' +
  'ประเภทที่คำนวณอัตโนมัติไม่ต้องกรอกวัน ส่วนประเภทปฏิทินให้กรอกช่วงวันล่วงหน้าปีละครั้ง';

const nextDay = (day) => {
  const date = new Date(`${day}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + 1);
  return date.toISOString().slice(0, 10);
};

// admin-api deletes at most this many days per request.
const MAX_RANGE_DAYS = 31;

// Consecutive days with the same name, as entered through the range form, cut every
// MAX_RANGE_DAYS days so each range can be deleted in one request.
export const calendarRanges = (rows) => {
  const ranges = [];
  [...rows]
    .sort((a, b) => a.day.localeCompare(b.day))
    .forEach((row) => {
      const last = ranges[ranges.length - 1];
      if (last && last.name === row.name && nextDay(last.end) === row.day && last.days < MAX_RANGE_DAYS) {
        last.end = row.day;
        last.days += 1;
      } else {
        ranges.push({ start: row.day, end: row.day, name: row.name, days: 1 });
      }
    });
  return ranges;
};

// One group per catalog kind, calendar kinds with their rows as ranges.
export const specialDayGroups = (kinds, rows) =>
  kinds.map((kind) => ({
    ...kind,
    ranges: kind.type === 'calendar' ? calendarRanges(rows.filter((row) => row.kind === kind.kind)) : [],
  }));

export const parseKinds = (value) =>
  (value || '')
    .split(',')
    .map((kind) => kind.trim())
    .filter((kind) => kind !== '');

// The earliest count dates on which any of the selected kinds falls.
export const nextSpecialDates = (kinds, selected, count = 3) => {
  const dates = kinds.filter(({ kind }) => selected.includes(kind)).flatMap(({ next_dates: next }) => next);
  return [...new Set(dates)].sort().slice(0, count);
};
